exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".DynamicTags .el-tag+.el-tag[data-v-d3f1aa3a]{margin-left:10px}.DynamicTags .button-new-tag[data-v-d3f1aa3a]{margin-left:10px;height:32px;line-height:30px;padding-top:0;padding-bottom:0}.DynamicTags .input-new-tag[data-v-d3f1aa3a]{width:90px;margin-left:10px;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d3f1aa3a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicTags/index.vue
// module id = 322
// module chunks = 0